module.exports = __webpack_public_path__ + "img/logo_navbar.58a708d1.png";